import { api } from "@services/api"
import {
  vehicleModelsService,
  addVehicleService,
  getVehiclesService,
  getSingleVehicleService,
  getAllVehiclesService,
  editVehicleService,
} from "./vehicles-service"
import { setList } from "@services/global-slice"

export const addVehicleApi = api.injectEndpoints({
  endpoints: (build) => ({
    //getVehicleModels
    getVehicleModels: build.query({
      queryFn: async () => {
        const result: any = await new Promise((resolve) =>
          vehicleModelsService()
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error })
              }
            })
        )
        return { data: result, error: result.error }
      },
      providesTags: ["VehicleModels"],
    }),

    //addVehicle
    addVehicle: build.mutation({
      queryFn: async (body) => {
        const result: any = await new Promise((resolve) =>
          addVehicleService(body)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )
        return { data: result, error: result.error }
      },

      invalidatesTags: ["Vehicle"],
    }),

    //getSingleVehicle - get a single by the vehicle vid
    getSingleVehicle: build.query({
      queryFn: async (vid) => {
        const result: any = await new Promise((resolve) =>
          getSingleVehicleService(vid)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )

        return { data: result, error: result.error }
      },
      providesTags: ["Vehicle"],
    }),

    //getVehicles all the vehicles that belong to a user
    getVehicles: build.query({
      queryFn: async ({ uid }) => {
        const result: any = await new Promise((resolve) =>
          getVehiclesService(uid)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )

        return { data: result, error: result.error }
      },
      providesTags: ["Vehicle"],
    }),

    //getAllVehicles - get all vehicles used by admins only
    getAllVehicles: build.query({
      queryFn: async ({ createdAt, key, value }) => {
        const result: any = await new Promise((resolve) =>
          getAllVehiclesService(createdAt, key, value)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )

        return { data: result, error: result.error }
      },
      providesTags: ["AllVehicles"],
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        const data = await queryFulfilled
        dispatch(setList({ list: "AllVehicles", id: arg.id, data: data.data }))
      },
    }),

    //editVehicle
    editVehicle: build.mutation({
      queryFn: async (body) => {
        const result: any = await new Promise((resolve) =>
          editVehicleService(body)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )
        return { data: result, error: result.error }
      },

      invalidatesTags: ["Vehicle"],
    }),
  }),
})

export const {
  useAddVehicleMutation,
  useGetVehicleModelsQuery,
  useGetSingleVehicleQuery,
  useGetVehiclesQuery,
  useGetAllVehiclesQuery,
  useEditVehicleMutation,
} = addVehicleApi
